import { AuthenticatedNotification, BroadcastUserChannelType } from "@/enums/enums";
import { GetUserProfileFromCache } from "@/helper/cacheHelper";
import { SocketDisconnect } from "@/helper/notificationHelper";
import { InsertTabIdToTabDB, UpdateTabMerchantId } from "@/helper/tabHelper";
import { MerchantId, UserId } from "@/helper/userHelper";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { UserModel } from "@/model/user/userModel";
import store from "@/store";

let userChannel: BroadcastChannel | null = null;

async function CacheUpdateUserProfileFromBroadcast(): Promise<void> {
  const userId: number = UserId();

  if (userId) {
    const userProfileCache: UserModel | null = await GetUserProfileFromCache(userId);

    if (userProfileCache && userProfileCache.userId > 0) {
      store.commit("LogIn/MutationSetUserModel", userProfileCache);
    }
  }
}

async function CacheUpdateSelectedMerchantFromBroadcast(): Promise<void> {
  const merchantId: number = MerchantId();

  if (merchantId) {
    store.commit("LogIn/MutationReSetMerchantModelList");

    const selectedMerchant: SelectedMerchantModel | null = await store.dispatch("LogIn/DoGetMerchantByResetCache", {
      merchantId: merchantId,
      isUseMainDatabase: true,
    });
  }
}

export const BroadcastInUserChannel = () => {
  if (userChannel) {
    userChannel.postMessage("Test");
  }
};

export const BroadcastUserMasterChannel = () => {
  if (userChannel) {
    userChannel.postMessage("toUserChannelMaster");
  }
};

export const BroadcastAuthenticatedNotificationStatus = (
  authenticatedNotificationStatus: AuthenticatedNotification
) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.AuthenticatedNotification,
      request: {
        authenticatedNotificationStatus: authenticatedNotificationStatus,
      },
    });
  }
};

export const BroadcastDisconnectNotification = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.DisconnectNotification,
      request: null,
    });
  }
};

export const BroadcastDisconnectNotificationAllTab = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.DisconnectNotificationAllTab,
      request: null,
    });
  }
};

export const BroadcastReCreateTab = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.ReCreateTab,
      request: null,
    });
  }
};

export const BroadcastCacheUpdateUserProfile = (): void => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.CacheUpdateUserProfile,
      request: null,
    });
  }
};

export const BroadcastCacheUpdateSelectedMerchant = (): void => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: BroadcastUserChannelType.CacheUpdateSelectedMerchant,
      request: null,
    });
  }
};

const AuthenticatedNotificationFromBroadcast = (authenticatedNotificationStatus: AuthenticatedNotification) => {
  if (authenticatedNotificationStatus == AuthenticatedNotification.Success) {
    store.commit("Notification/MutationSetNotificationReadyToUse", true, { root: true });
  } else {
    store.commit("Notification/MutationSetNotificationReadyToUse", false, { root: true });
  }
};

const DisconnectNotificationFromBroadcast = () => {
  store.commit("Notification/MutationSetNotificationReadyToUse", false, { root: true });
};

const DisconnectNotificationAllTabFromBroadcast = () => {
  SocketDisconnect();
  store.commit("Notification/SOCKET_disconnect", null, { root: true });
};

const ReCreateTabFromBroadcast = async () => {
  const merchantId = MerchantId();
  await InsertTabIdToTabDB();
  await UpdateTabMerchantId(merchantId);
};

export const SetUserChannel = (userId: number) => {
  if (userChannel) {
    userChannel.close();
  }
  userChannel = new BroadcastChannel(userId.toString());

  userChannel.onmessage = async (event) => {
    if (event.data) {
      switch (event.data.broadcastType) {
        case BroadcastUserChannelType.AuthenticatedNotification:
          AuthenticatedNotificationFromBroadcast(event.data.request.authenticatedNotificationStatus);
          break;
        case BroadcastUserChannelType.DisconnectNotification:
          DisconnectNotificationFromBroadcast();
          break;
        case BroadcastUserChannelType.DisconnectNotificationAllTab:
          DisconnectNotificationAllTabFromBroadcast();
          break;
        case BroadcastUserChannelType.ReCreateTab:
          ReCreateTabFromBroadcast();
          break;
        case BroadcastUserChannelType.CacheUpdateUserProfile:
          CacheUpdateUserProfileFromBroadcast();
          break;
        case BroadcastUserChannelType.CacheUpdateSelectedMerchant:
          CacheUpdateSelectedMerchantFromBroadcast();
          break;
      }
    }
  };
};
